import { render } from "./showCard.vue?vue&type=template&id=fb181016"
const script = {}

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__